import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callMonnetApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { getStrLang } from '../../Translate';


const MonnetPayment = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingMonnetInfo, setLoadingMonnetInfo] = useState(false);
    const [infoMonnet, setInfoMonnet] = useState({});
    const [waitingPayment, setWaitingPayment] = useState(false);
    const [isError, setIsError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [link, setLink] = useState("");
    const [tabOpened, setTabOpened] = useState(false);
    const [cbu, setCbu] = useState("");
    const [showCbuInput, setShowCbuInput] = useState(false);
    const [country, setCountry] = useState(sessionStorage.getItem("country") || "");

    useEffect(() => {
        translate();
        // Check if country is Argentina and payment type is monnet_bank_transfer to show CBU input
        if (country && country.toLowerCase() === 'ar' && props.payment_type === 'monnet_bank_transfer') {
            setShowCbuInput(true);
        } else {
            setShowCbuInput(false);
        }
    }, [translate, country, props.payment_type]);



    const callMonnet = () => {
        setLoadingMonnetInfo(true);
        
        // For Argentina with monnet_bank_transfer, check if CBU is required and provided
        if (showCbuInput && !cbu.trim()) {
            setErrorMsg("CBU is required for Argentina bank transfer");
            setLoadingMonnetInfo(false);
            setIsError(true);
            return;
        }

        callMonnetApi(sessionStorage.getItem("order_no"), props.payment_type, showCbuInput ? cbu : null)
            .then(res => {
                if (res !== undefined) {
                    setInfoMonnet({ ...infoMonnet, [props.payment_type]: res });
                    setLoadingMonnetInfo(false)

                    // If it's monnet_bank_transfer, set the link and open in new tab
                    if (props.payment_type === 'monnet_bank_transfer' && res.url) {
                        setLink(res.url);
                        window.open(res.url, '_blank');
                        setTabOpened(true);
                    }
                } else {
                    setErrorMsg("Please, talk with the Administrator.");
                    setLoadingMonnetInfo(false);
                    setIsError(true)
                }
            })
            .catch(err => {
                console.log(err.toString());
                setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error")
                setIsError(true)
            }).finally(() => {
                setLoadingMonnetInfo(false);
                translate();
            });
    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingMonnetInfo]);


    useEffect(() => {
        // Always call API to get fresh URL
        callMonnet()
        return () => {
            const iframe = document.getElementById('monnet_frame');
            if (iframe) {
                iframe.removeEventListener('load', () => { })
            }
        }
    }, [showCbuInput, props.payment_type])
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href = redirectedUrl
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <>
            {loadingMonnetInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {/* CBU Input for Argentina */}
            {showCbuInput && infoMonnet[props.payment_type] === undefined && !loadingMonnetInfo && (
                <div className='row'>
                    <div className='col-md-12 d-flex justify-content-center'>
                        <form 
                            style={{ minWidth: "70%" }}
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (cbu.trim()) {
                                    callMonnet();
                                }
                            }}
                        >
                            <div className='form-group'>
                                <label htmlFor="cbu-input">CBU</label>
                                <input
                                    id="cbu-input"
                                    type="text"
                                    pattern="[0-9]*"
                                    inputMode="numeric"
                                    placeholder="CBU"
                                    value={cbu}
                                    onChange={(e) => {
                                        // Only allow numbers
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setCbu(value);
                                        if (isError) {
                                            setIsError(false);
                                            setErrorMsg("");
                                        }
                                    }}
                                    className='form-control'
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={!cbu.trim()}
                                style={{
                                    cursor: cbu.trim() ? 'pointer' : 'not-allowed',
                                }}
                                className='btn btn-primary btn-block'
                            >
                                {getStrLang(lang.nameLang, "Save")}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            <div className=''>
                {infoMonnet[props.payment_type] !== undefined ? (
                    <>
                        {props.payment_type === 'monnet_bank_transfer' ? (
                            <div style={{ textAlign: "center", marginTop: 40 }}>
                                <p>The payment page has opened in a new tab.</p>
                                {link && (
                                    <a href={link} target="_blank" rel="noopener noreferrer">
                                        Click here if it didn't open automatically
                                    </a>
                                )}
                            </div>
                        ) : (
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                    {loading && <div className="loader"> <img src={Loading} alt={"loading"} width="30px" height="30px" /></div>}
                                </div>

                                <iframe
                                    id='monnet_frame'
                                    src={`${infoMonnet[props.payment_type]['url']}`}
                                    title={`${props.payment_type}`}
                                    width="100%"
                                    height="800px"
                                    onLoad={handleLoad}
                                    style={{ display: loading ? 'none' : 'block' }}
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <></>
                )}

                {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>{errorMsg}</h4>
                </div>}
            </div>
        </>
    )
}

export default MonnetPayment;